// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-logger').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-logger/build.source.js
// module id = 282
// module chunks = 7